module.exports = __webpack_public_path__ + "static/media/cn.ce4c8db3.svg";